import * as React from "react";
import {cx} from "emotion";

import "./social-sharing.scss";

import {cs}                 from "@Common/react/chain-services";
import {consumeContext}     from "@Common/react/context";
import {UseState}           from "@Common/react/use-state";
import {createGroupPostId}  from "@Common/ui-components/heavy/social/create-group-post-id";
import {ShareResultModal}   from "@Common/ui-components/heavy/social/share-result-modal/share-result-modal";
import {ShareTargets}       from "@Common/ui-components/heavy/social/share-targets";
import {SharingDetailsForm} from "@Common/ui-components/heavy/social/sharing-details-form/sharing-details-form";

import {EmulationControl} from "../../../../layout/desktop/header/right-nav/emulation-control/emulation-control";

export const SocialSharing = ({getImage, showEmulation=false}) => cs(
    consumeContext("userLevels"),
    ["form", (_, next) => SharingDetailsForm({next})],
    ["targets", (_, next) => ShareTargets({
        isPlatformSelectedInitially: (platformName) => true,
        next,
    })],
    ["showErrors", (_, next) => UseState({next})],
    ({targets, form, showErrors, userLevels}) => (
        <div className="social-sharing-787">
            <div
                className="header"
            >
                <div
                    className="title"
                    xd-qa-type="label" xd-qa-name="Social Sharing"
                >
                    Social Sharing
                </div>
                {(showEmulation && (userLevels?.userLevel === 3 || userLevels?.userLevel === 4)) ? EmulationControl({
                    hidden: null,
                    emulationPlugins: null,
                    limitByBenefit: 'seasonalContent'
                }) : <></>}
            </div>

            <div className="form">
                {form.renderMain({
                    restrictCommentLength: targets.getRestrictCommentLength({url: form.getUrl()}),
                    showErrors: showErrors.value,
                })}

                <div className="line targets">
                    <div className="right">
                        {!targets.available ? (
                            <div className="no-account-msg" >
                                To link your Social Media account(s), please return to your Account Page to Manage Social Media Accounts.
                            </div>
                        ) : (
                            targets.render()
                        )}
                    </div>
                </div>

                {form.renderScheduler({
                    showErrors: showErrors.value,
                })}

                <div className="line actions">
                    <div className="right">
                        {cs(
                            ["resultModal", ({}, next) => ShareResultModal({next})],
                            ["submitting", (_, next) => UseState({next})],
                            ({resultModal, submitting}) => (
                                <button {...{
                                    className: cx({
                                        disabled: (
                                            !targets.hasSelectedTargets() ||
                                            !form.valid
                                        )
                                    }),
                                    disabled: (
                                        submitting.value
                                    ),
                                    onClick: async () => {
                                        if (!form.valid) {
                                            form.highlightErrors?.();
                                            showErrors.onChange(true);
                                            return;
                                        }
                                        const sharePieces = targets.getSharePieces();
                                        if (!sharePieces?.length) {
                                            alert("No social platform selected");
                                            return;
                                        }
                                        submitting.onChange(true);
                                        const id_group_post = createGroupPostId();
                                        const ccImage = getImage();
                                        const results = await Promise.all(targets.getSharePieces().map(async (sharePiece) => ({
                                            type: sharePiece.type,
                                            result: await sharePiece.invokeShare({
                                                ...form.getPostData(),
                                                ccImage,
                                                id_group_post,
                                            }),
                                        })));
                                        resultModal.show(results);
                                        submitting.onChange(false);
                                    },

                                    "xd-qa-type": "button",
                                    "xd-qa-name": form.isSchedulingEnabled() ? (
                                        "Schedule Post"
                                    ) : (
                                        "Share"
                                    ),
                                }}>
                                    {!submitting.value ? (
                                        form.isSchedulingEnabled() ? (
                                            "Schedule Post"
                                        ) : (
                                            "Share"
                                        )
                                    ) : <>
                                        {form.isSchedulingEnabled() ? (
                                            "Scheduling"
                                        ) : (
                                            "Sharing"
                                        )}
                                        ...{" "}
                                        <i className="fa fa-spinner fa-pulse"/>
                                    </>}
                                </button>
                            )
                        )}
                    </div>
                </div>
            </div>
        </div>
    ),
);
